//获取cookie、
export function getCookie(name) {
  var arr,
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if ((arr = document.cookie.match(reg))) return arr[2];
  else return null;
}

//设置cookie,增加到vue实例方便全局调用    //expiredays==null时关闭浏览器自动清除cookie
export function setCookie(c_name, value, expiredays) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie =
    c_name +
    "=" +
    escape(value) +
    (expiredays == null ? "" : ";expires=" + exdate.toGMTString());
}

//删除cookie
export function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}

export function getDate() {
  var dd = new Date();
  var y = dd.getFullYear();
  var M =
    dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
  var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
  var h = dd.getHours() < 10 ? "0" + dd.getHours() : dd.getHours();
  var m = dd.getMinutes() < 10 ? "0" + dd.getMinutes() : dd.getMinutes();
  var s = dd.getSeconds() < 10 ? "0" + dd.getSeconds() : dd.getSeconds();
  //   return y + '-' + m + '-' + d
  return y + "" + M + "" + d + "" + h + "" + m + "" + s;
}

// 权限控制
export function getPermission(code){
  let list = JSON.parse(sessionStorage.getItem("list"));
  return list.findIndex( item => item.id == code ) !== -1
}

export default{
  getPermission
}



// WEBPACK FOOTER //
// ./src/utils/utils.js